import type { PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addMessageAPI,
  addThreadAPI,
  patchThreadAPI,
} from "redux/services/threads";
import { apiErrorCatcher } from "./common-action-utils";

interface ThreadState {
  loading: boolean;
  error: string | null;
}

const initialState: ThreadState = {
  loading: false,
  error: null,
};

export const addThread = createAsyncThunk(
  "thread/addThread",
  async (payload: any, thunkAPI) => {
    try {
      const response = await addThreadAPI(payload);
      return response.data;
    } catch (error: any) {
      apiErrorCatcher(error, thunkAPI.dispatch);
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const patchThread = createAsyncThunk(
  "thread/patchThread",
  async (payload: { id: number; data: any }, thunkAPI) => {
    const { id, data } = payload;
    try {
      const response = await patchThreadAPI(id, data);
      return response.data;
    } catch (error: any) {
      apiErrorCatcher(error, thunkAPI.dispatch);
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const addMessage = createAsyncThunk(
  "thread/addMessage",
  async (payload: any, thunkAPI) => {
    try {
      console.log("payload: ", payload);

      const response = await addMessageAPI(payload);
      return response.data;
    } catch (error: any) {
      apiErrorCatcher(error, thunkAPI.dispatch);
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const threadSlice = createSlice({
  name: "thread",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // add thread
      .addCase(addThread.pending, (state) => {
        state.loading = true;
      })
      .addCase(addThread.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addThread.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      // edit thread
      .addCase(patchThread.pending, (state) => {
        state.loading = true;
      })
      .addCase(patchThread.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(patchThread.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      // add message
      .addCase(addMessage.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMessage.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addMessage.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default threadSlice.reducer;
